import { render, staticRenderFns } from "./DefaultRating.vue?vue&type=template&id=abdf92d2&scoped=true"
import script from "./DefaultRating.vue?vue&type=script&lang=js"
export * from "./DefaultRating.vue?vue&type=script&lang=js"
import style0 from "./DefaultRating.vue?vue&type=style&index=0&id=abdf92d2&prod&scoped=true&lang=css"
import style1 from "./DefaultRating.vue?vue&type=style&index=1&id=abdf92d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abdf92d2",
  null
  
)

export default component.exports